import * as z from "zod";

export const deleteCustomDomain = {
  name: "deleteCustomDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.null(),
};
